import React from 'react'
import { globalConstants } from "../constants/globalConstants";
import UtilService from "../services/util.service";
import userResponseComponent from "../components/message-components/user-response.component";
import ChatBotApiService from '../services/chatbot-api.service';
import GlobalStoreService from "../services/global-store.service";
import ChatActionType from '../enums/action-types/ChatActionType';
import ActionHandlerService from '../services/actions-handler.service';

import ActionHandlerService2 from '../services/actions-handler.service2';
import { handleInitializationErrors } from '../services/handle-initialization-errors.service'

const executeAction = (actionObject, data, retry_count, chatBotQuery) => {
    return new Promise((resolveExecuteAction, rejectExecuteAction) => {
        let missingInitialParams = UtilService.checkIfInitializationParamsMissing()
        if (missingInitialParams) {
            handleInitializationErrors(missingInitialParams).then(
                result => {

                    if (result === 'INITIATE_AFTER_LOGIN_IN_MULTIPLE') {
                        let response = {}
                        response['INITIATE_AFTER_LOGIN_IN_MULTIPLE'] = true

                        resolveExecuteAction(response);
                    }
                    else {
                        // console.log('errorcehck success')
                        executeAfterErrorCheck(actionObject, data, retry_count, chatBotQuery).then(
                            result => resolveExecuteAction(result),
                            error => rejectExecuteAction(error)
                        )
                    }
                },
                error => {
                    // console.log()
                    rejectExecuteAction()
                }
            )
        }
        else {
            executeAfterErrorCheck(actionObject, data, retry_count, chatBotQuery).then(
                result => resolveExecuteAction(result),
                error => rejectExecuteAction(error)
            )
        }

    })

}

const executeAfterErrorCheck = (actionObject, data, retry_count, chatBotQuery) => {
    return new Promise(function (resolve, reject) {
        if (isInitiateScenario(actionObject.action)) {
            ActionHandlerService2.initiateScenario((data && data.scenarioId) ? data : data.scenarioResponse, resolve, reject, retry_count);
        }
        else if (isFeedbackAction(actionObject.action)) {
            ActionHandlerService2.initiateScenario(data.scenarioResponse, resolve, reject, retry_count);
        }
        else if (isChatInAction(actionObject.action)) {
            ActionHandlerService2.executeChatIn(data, resolve, reject, retry_count, chatBotQuery);
        }
        else if (isChatOutAction(actionObject.action)) {
            ActionHandlerService2.executeChatOut(
                actionObject.payload.user_response ? actionObject.payload.user_response : data.user_response,
                resolve,
                reject, retry_count,
                chatBotQuery);
        }
        else if (isLinkAsChoiceAction(actionObject.action)) {
            ActionHandlerService.handleLinkAsChoiceWithinScenario(
                data,
                resolve,
                reject
            );
        }
        else if (isBookMarkAction(actionObject.action)) {
            ActionHandlerService.handleBookmarkOptionWithinScenario(
                ActionHandlerService.getBookmarkedScenarioIdForChoice(data.user_response, data.scenarioResponse),
                resolve,
                reject, retry_count
            );
        } else if (isAskForLoginAction(actionObject.action)) {
            // GlobalStoreService.set("components_handler", {...GlobalStoreService.get('components_handler'),bottom_bar_comp:'login-comp'});
            let chatItem = {}
            chatItem.response = globalConstants.login_message
            if (GlobalStoreService.get('loginSessionExpired')) {
                chatItem.response = globalConstants.login_again_message
                GlobalStoreService.set('loginSessionExpired', false)
            }
            chatItem.sentTime = UtilService.getCurrentTime();
            let message_objects = [];
            message_objects.push({ component_type: 'DEFAULT', message: chatItem.response, messageTime: chatItem.sentTime })
            resolve({ message_objects, bottom_comp: { type: globalConstants.BOTTOM_BAR_COMPONENTS.LOGIN_COMPONENT } })

        } else if (isCreateSrAction(actionObject.action)) {
            const data = actionObject.payload;
            ActionHandlerService.handleCreateSr({ data, resolve, reject });
        } else if (isCountrySelect(actionObject.action)) {
            ActionHandlerService2.executeChatIn({ "scenarioResponse": actionObject.payload }, resolve, reject, retry_count);
        }
        else if (isNoActionChosen(actionObject.action)) {
            let chatItem = {}
            chatItem['response'] = globalConstants.default_error_message
            reject({ message_objects: [{ component_type: 'DEFAULT', message: chatItem.response, messageTime: UtilService.getCurrentTime() }] })

        }
    });
}


const isInitiateScenario = (actionType) => {
    return (actionType === ChatActionType.INITIATE);
};

const isUserResponseAction = (actionType) => {
    return (actionType === ChatActionType.USER_RESPONSE);
};

const isFeedbackAction = (actionType) => {
    return (actionType === ChatActionType.FEEDBACK_ACTION);
};

const isChatInAction = (actionType) => {
    return (actionType === ChatActionType.CHAT_IN);
};

const isChatOutAction = (actionType) => {
    return (actionType === ChatActionType.CHAT_OUT);
};

const isLinkAsChoiceAction = (actionType) => {
    return (actionType === ChatActionType.CHOICE_OPTION_LINK);
};

const isBookMarkAction = (actionType) => {
    return (actionType === ChatActionType.BOOKMARK);
};

const isAskForLoginAction = (actionType) => {
    return (actionType === ChatActionType.ASK_FOR_LOGIN);
};

const isCreateSrAction = (actionType) => {
    return (actionType === ChatActionType.CREATE_SR);
};

const isCountrySelect = (actionType) => {
    return (actionType === ChatActionType.COUNTRY_SELECT);
};

const isNoActionChosen = (actionType) => {
    return (actionType === ChatActionType.NO_ACTION_CHOSEN);
};




export {
    executeAction
};



// WEBPACK FOOTER //
// ./src/actions/execute.action.js